import React from "react"
import { Link, graphql, PageProps } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"

type Data = {
  allMdx: {
    edges: {
      node: {
        excerpt: string
        fields: {
          slug: string
        }
        frontmatter: {
          title: string
          date?: string
          description?: string
          status?: string
          stack?: string
        }
      }
    }[]
  }
}

const ExperimentsPage = ({ data }: PageProps<Data>) => {
  const experiments = data.allMdx.edges

  return (
    <Layout activePage="experiments">
      <SEO title="Mini Experiments" />
      <div className="container">
        <div className="page-header fade-hero">
          <div className="page-eyebrow">02 — MINI EXPERIMENTS</div>
          <div className="page-title">Mini Experiments</div>
          <div className="page-desc">
            Small builds, tests, and things I tried for no good reason. Some work. Most are
            just interesting.
          </div>
        </div>

        {experiments.length === 0 ? (
          <div className="empty-state fade-content">
            nothing here yet
            <p>check back soon.</p>
          </div>
        ) : (
          <div className="entry-list fade-content">
            {experiments.map(({ node }) => (
              <Link key={node.fields.slug} className="entry" to={node.fields.slug}>
                <div className="entry-meta">
                  {[node.frontmatter.status, node.frontmatter.date]
                    .filter(Boolean)
                    .join(" / ")}
                </div>
                <div className="entry-title">{node.frontmatter.title}</div>
                <p className="entry-desc">
                  {node.frontmatter.description || node.excerpt}
                </p>
                {node.frontmatter.stack ? (
                  <div className="entry-tag">{node.frontmatter.stack}</div>
                ) : null}
              </Link>
            ))}
          </div>
        )}

      </div>
    </Layout>
  )
}

export default ExperimentsPage

export const pageQuery = graphql`
  query {
    allMdx(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { fields: { collection: { eq: "mini-apps" } } }
    ) {
      edges {
        node {
          excerpt(pruneLength: 160)
          fields {
            slug
          }
          frontmatter {
            title
            date(formatString: "MMM DD, YYYY")
            description
            status
            stack
          }
        }
      }
    }
  }
`
